// API Service Layer for Travel+ CRM
import axios from 'axios';
import errorLogger from './errorLogger';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001/api';

// Create axios instance with defaults
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests if available
api.interceptors.request.use(
  (config) => {
    // Don't add auth header for certain endpoints
    const noAuthEndpoints = [
      '/auth/login',
      '/auth/2fa/send',
      '/auth/2fa/verify',
      '/registration/agency',
      '/registration/independent'
    ];
    
    const requiresAuth = !noAuthEndpoints.some(endpoint => config.url.includes(endpoint));
    
    const token = localStorage.getItem('token');
    if (token && requiresAuth) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle responses and errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Log API errors (except for error-logs endpoint to avoid infinite loop)
    // Only log if user is authenticated (has token)
    const hasToken = localStorage.getItem('token');
    if (hasToken && error.config && !error.config.url.includes('/error-logs')) {
      // Don't log 401 errors (authentication) or 404 errors (expected)
      const status = error.response?.status;
      if (status && status !== 401 && status !== 404) {
        errorLogger.logApiError(error);
      }
    }

    if (error.response?.status === 401) {
      // Check if we're on a public page - don't redirect for these
      const currentPath = window.location.pathname;
      const publicPaths = [
        '/quote/',
        '/payment/',
        '/mst/login',
        '/yeti/login',
        '/bwk/login',
        '/mst/register',
        '/yeti/register',
        '/bwk/register',
        '/independent',
        '/admin',
        '/'
      ];
      
      const isPublicPath = publicPaths.some(path => currentPath.includes(path));
      
      if (!isPublicPath) {
        // Only redirect to login for protected pages
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
